import React from "react";

export function IconAction({ title, onClick, disabled, danger, icon }) {
  return (
    <button type="button" className={`accounts-icon-btn${danger ? " danger" : ""}`} title={title} aria-label={title} disabled={disabled} onClick={onClick}>
      <i className={`bi ${icon}`} />
    </button>
  );
}

export function ViewIcon(props) {
  return <IconAction title="View" icon="bi-eye" {...props} />;
}

export function CancelIcon(props) {
  return <IconAction title="Cancel" icon="bi-slash-circle" danger {...props} />;
}

export function EditIcon(props) {
  return <IconAction title="Edit" icon="bi-pencil" {...props} />;
}
